'use strict';

var _ = require('lodash');
var PubSub = require('tscom-pubsub');
var template = require('../templates/vote-option.ejs');
var templateAlt = require('../templates/vote-option-finalist.ejs');

var VoteOptionView = require('standard-vote/app/scripts/views/vote-option');

module.exports = VoteOptionView.extend({

    render: function () {

        var dataLength = this.dataLength;
        var model = this.model.toJSON();

        var isEliminated = _.checkIfTrue(model.eliminated);

        // check length of vote option name and slice it
        var fullName = model.firstname + ' ' + model.lastname;
        if(fullName.length >= 74) fullName = fullName.slice(0,73);
        model.fullname = fullName;

        var text = this.cms.get('text')['views_nominee_grid'];

        //check the length of the contestants, render different layout based on contestant length
        if (dataLength === 2 || dataLength === 4) {
            this.$el.html(templateAlt({
                model: model,
                text: text,
                isEliminated: isEliminated
            }));
            return this;
        }

        this.$el.html(template({
            model: model,
            text: text,
            isEliminated: isEliminated
        }));

        return this;
    },

    selectContestant: function (e) {
        e.preventDefault();
        this.voteOption.setSelected(this.model.get('id'));

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Select Contestant',
            label: 'Button Click: Select Contestant'
        };

        PubSub.trigger('scrollToTop');
        PubSub.trigger('trackGoogle',evt);
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/vote-option.js